import { loader } from '@monaco-editor/react';

export const MIMO_THEME = {
  base: 'vs-dark' as any, // should be of type BuiltinTheme
  inherit: true,
  rules: [
    { background: '#191B33', token: '' },
    // {
    //   foreground: '#00b5ec',
    //   token: 'delimiter.html',
    // },
  ],
  colors: {
    'editor.background': '#191B33', //product2-background-dark
    'editor.lineHighlightBackground': '#4D4D87', //night-300
    'editorCursor.foreground': '#FFFFFF', //snow-50
    'editorLineNumber.foreground': '#6971A6', //night-100
    'editorLineNumber.activeForeground': '#FFFFFF', //snow-50
  },
};

loader.config({
  paths: {
    vs: '/monaco-editor/min/vs',
  },
});

export const MONACO_BASE_OPTIONS = {
  automaticLayout: true,
  minimap: {
    enabled: false,
  },
  scrollBeyondLastLine: false,
  scrollbar: {
    alwaysConsumeMouseWheel: false,
  },
  tabSize: 2,
  fontSize: 14,
  fontFamily: 'var(--font-aeonikMono)',
  lineHeight: 21,
  wrappingIndent: 'same' as any,
  padding: { top: 20, bottom: 20 },
  readOnly: true,
  renderLineHighlightOnlyWhenFocus: true,
  renderLineHighlight: 'none' as any,
  suggest: {
    snippetsPreventQuickSuggestions: false,
  },
  guides: { indentation: true },
  colorDecorators: false,
  renderWhitespace: 'none' as any,
  unicodeHighlight: {
    invisibleCharacters: false,
    ambiguousCharacters: false,
  },
  overviewRulerLanes: 0,
};
